import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import { isOrderPerformanceModuleEnabled } from '../../../../../constants/orderPerformanceFeatureFlags';
import { useOrderContext } from '../../../../../providers/OrderProvider';
import { useOrderPerformanceFeatures } from '../../../../../providers/OrderPerformanceFeaturesProvider';
import OrderRewardSection from './OrderRewardSection';

const OrderRewardMediaContent = ({ forceVisible = false }) => {
	const { orderDetailUi } = useOrderPerformanceFeatures();
	const { order } = useOrderContext();

	if (!isOrderPerformanceModuleEnabled() || (!orderDetailUi && !forceVisible) || order?.uiHints?.isLegacyCompletedBeforeFinalCostCutoff) {
		return null;
	}

	return (
		<EventModalMediaContent icon='gift' heading='奖励'>
			<OrderRewardSection />
		</EventModalMediaContent>
	);
};

export default OrderRewardMediaContent;
